<template>
  <div>
    <CustomOverlay :show="show_overlay" :text="overlay_text">
      <b-container class="min-vh-100">
        <b-row class="min-vh-100 justify-content-md-center align-items-center">
          <b-col lg="5">
            <!-- Logo customer -->
            <b-img class="mb-3" center fluid :style="customer_styles.img_logo_style" :src="customer_styles.img_logo"></b-img>
            <!-- Sottotitolo logo -->
            <p v-if="customer_styles.logo_subtitle.visible"
                class="text-center mt-2 mb-2"
                :style="customer_styles.logo_subtitle.style">
                {{customer_styles.logo_subtitle.text}}
            </p>

            <!-- ***********FORM DI LOGIN************* -->
            <!-- SCHERMATA 1 USERNAME E PASSWORD: Form di Login per username e password -->
            <b-form v-if="!show_otp && !show_qr_code" @submit.prevent="prosegui_ad_otp" class="p-4" :style="customer_styles.form_body">

              <h6 class="text-center" :style="customer_styles.username_text_and_icon">Accesso Piattaforma Welfare Dipendenti</h6>

              <!-- Inserimento username -->
              <b-form-group
                :style="customer_styles.username_text_and_icon"
                id="username-group"
                label="Username:"
                label-for="username"
                style="color:#ffffff"
              >
                <b-input-group>
                  <b-input-group-prepend class="pr-1">
                    <b-icon icon="person" font-scale="2"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="username"
                    v-model="username"
                    type="email"
                    :state="username_state"
                    required
                    placeholder="Scrivi lo username"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <!-- Inserimento password -->
              <b-form-group
                :style="customer_styles.passwd_text_and_icon"
                id="password-group"
                label="Password:"
                label-for="password"
              >
                <b-input-group>
                  <b-input-group-prepend class="pr-2">
                    <b-icon icon="eye-slash" font-scale="2"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="password"
                    v-model="password"
                    type="password"
                    :state="password_state"
                    required
                    placeholder="Scrivi la password"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <!-- Pulsanti di azione -->
              <b-row align-h="center">
                <b-col class="text-center">
                  <b-button id="access_button" type="submit" :style="customer_styles.access_button" >Accedi</b-button>
                </b-col>
                <b-col class="text-center">
                  <b-button size='sm' class="mt-1" @click="show_recovery_modal" :style="customer_styles.passwd_lost_button">
                    <small>Password dimenticata?</small>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
            <!-- END - SCHERMATA 1 USERNAME E PASSWORD -->

            <!-- SCHERMATA 2 VERIFICA OTP CON AUTENTICATORE - ARRUOLAMENTO -->
            <b-form v-if="show_otp" @submit.prevent="verifica_otp" class="p-4" :style="customer_styles.form_body">

              <h6 class="text-center" :style="customer_styles.username_text_and_icon">Accesso Piattaforma Welfare Dipendenti</h6>

              <p class="text-justify" :style="customer_styles.username_text_and_icon" v-html="otp_code_label"></p>

              <!-- Se siamo in modalità OTP visualizziamo il link al manuale ed al video esplicativo -->
              <p v-if="is_enroll_otp || is_auth_otp" class="text-justify">
                <u><b>Hai bisogno di aiuto?</b></u> Ti invitiamo a consultare la nostra guida cliccando
                <b-link :href="url_manuale_otp" target="_blank"><b>QUI</b></b-link>
                 e a vedere un video dettagliato e consultare le FAQ cliccando
                <b-link :href="url_video_otp" target="_blank"><b>QUI</b></b-link>
              </p>

              <b-form-group
                :style="customer_styles.username_text_and_icon"
                id="otp-group"
                label="Inserisci il codice:"
                label-for="otp"
              >
                <b-input-group>
                  <b-input-group-prepend class="pr-1">
                    <b-icon icon="shield-lock" font-scale="2"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="otp"
                    v-model="otp"
                    type="text"
                    :state="otp_state"
                    required
                    :placeholder="otp_placeholder_label"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <!-- Pulsante per il controllo del codice OTP -->
              <b-row align-h="center">
                <b-col class="text-center">
                  <b-button id="access_button" type="submit" :style="customer_styles.access_button" >Verifica</b-button>
                </b-col>
                <b-col class="text-center">
                  <b-button @click="page_reload" :style="customer_styles.access_button" >Torna al login</b-button>
                </b-col>
              </b-row>
            </b-form>
            <!-- END - SCHERMATA 2 VERIFICA OTP CON AUTENTICATORE - ARRUOLAMENTO -->

            <!-- SCHERMATA 3 UNA BCARD CON DENTRO IL QR CODE PER LA REGISTRAZIONE DELLA SECRET DELL'AUTENTICATORE -->
            <b-card v-if="show_qr_code"
                title="Completamento registrazione:"
                class="ml-auto mr-auto mb-2"
              >
              <b-card-body class='text-center'>
                <p class='text-justify'>
                  Completa la registrazione del tuo account seguendo questi passaggi sotto riportati,
                  <b><u>se hai bisogno di aiuto</u></b>, ti invitiamo a consultare la nostra guida cliccando
                  <b-link :href="url_manuale_otp" target="_blank"><b>QUI</b></b-link>
                  e a vedere un video dettagliato e consultare le FAQ cliccando
                  <b-link :href="url_video_otp" target="_blank"><b>QUI</b></b-link> :
                </p>

                <!-- ISTRUZIONI: Step 1 - Installazione autenticatore -->
                <h5 class='text-left'><font-awesome-icon icon="mobile-alt" /> <i>STEP 1 - Installa il tuo autenticatore</i></h5>
                <p class='text-justify'>
                  Scarica e installa un'app di autenticazione sul tuo <b>smartphone o tablet</b>, puoi utilizzare ad esempio
                  <b>Google Authenticator</b>
                  disponibile sia per <b-link href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=it"> <font-awesome-icon :icon="['fab','google-play']" /> Android</b-link>
                  che <b-link href="https://apps.apple.com/us/app/google-authenticator/id388497605"> <font-awesome-icon :icon="['fab','apple']" /> iOS</b-link>.
                </p>

                <!-- ISTRUZIONI: Step 2 - Visualizzazione del QR Code -->
                <h5 class='text-left mt-4'><font-awesome-icon icon="camera" /> <i>STEP 2 - Inquadra il QR Code</i></h5>
                <p class='text-justify'>Apri l'app installata su <b>smartphone o tablet</b> al passo precedente e segui le istruzioni per aggiungere un nuovo account. Scansiona con la fotocamera del dispositivo il codice QR quando richiesto.</p>
                <b-img :src="qr_code_img" fluid alt="qrcode"></b-img>
                <p class='text-justify'>
                  In alternativa puoi inserire manualmente il <b>codice segreto</b> qui sotto,
                  clicca su di esso per copiarlo:
                </p>
                <h5 class='text-center'>
                  <b-link class="code-link" @click.prevent="copia_secret_negli_appunti">
                    {{otp_secret}}
                  </b-link>
                </h5>

                <!-- ISTRUZIONI: Step 3 - Conferma corretta registrazione con inserimento di un primo OTP -->
                <h5 class='text-left  mt-4'><font-awesome-icon icon="check-double" /> <i>STEP 3 - Conferma la registrazione</i></h5>
                <p class='text-justify'>
                  Per confermare la <b>corretta configurazione</b> apri la tua app di autenticazione dal tuo <b>smartphone o tablet</b> ed inserisci il codice di sicurezza
                  a sei cifre che verrà visualizzato come nell'<b>immagine di esempio qui sotto</b>, infine premi il pulsante di conferma in fondo.
                </p>
                <b-img class='mt-1 mb-3' :src="authenticator_image" fluid alt="authenticator image"></b-img>
                <b-form-group
                  :style="customer_styles.username_text_and_icon"
                  invalidFeedback="Immetti il codice visualizzato in app per confermare"
                  :state="otp_confirm_state"
                  id="otp-confirm-group"
                  label="Inserisci il codice di sicurezza visualizzato nella app di autenticazione sul tuo smartphone o tablet:"
                  label-for="otp-confirm"
                >
                  <b-input-group>
                    <b-input-group-prepend class="pr-1">
                      <b-icon icon="shield-lock" font-scale="2"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      id="otp-confirm"
                      v-model="otp_confirm"
                      type="text"
                      :state="otp_confirm_state"
                      required
                      placeholder="Codice di sicurezza"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-row class='mt-4'>
                    <b-col>
                      <b-button @click="conferma_registrazione_qrcode" variant="primary" :style="customer_styles.access_button">
                        Confermo la corretta registrazione del mio account.
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col>
                      <b-button @click="page_reload" variant="primary" :style="customer_styles.passwd_lost_button">
                        Annulla operazione e torna al login.
                      </b-button>
                    </b-col>
                  </b-row>
              </b-card-body>
            </b-card>
            <!-- END - SCHERMATA 3 BCARD QRCODE DI REGISTRAZIONE -->
            <!-- ***********END - FORM DI LOGIN************* -->

            <!-- Logo inferiore -->
            <b-img v-if="customer_styles.logo_inf.visible" class="mt-4" center :style="customer_styles.logo_inf.style" :src="customer_styles.logo_inf.img_logo"></b-img>
          </b-col>
        </b-row>
      </b-container>
    </CustomOverlay>

    <!-- RECUPERO PASSWORD PERDUTA -->
    <!-- Modale per il recupero password, il footer non lo renderizziamo -->
    <!-- usiamo i bottoni aggiunti sotto al form per la gestione -->
    <b-modal ref="passwd_recovery_modal"
        title="Recupero password dimenticata"
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        centered
        @show="reset_recovery_modal">
        <b-form @submit.prevent="esegui_password_recovery">
          <b-form-group
            label="Inserisci qui il tuo indirizzo email e premi ok per avviare la procedura di recupero password:"
            label-for="user-email-group"
          >
            <!-- Email utente -->
            <b-input-group class="pb-4 pt-4">
              <b-input-group-prepend class="pr-1">
                <b-icon icon="envelope" font-scale="2"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="user-email"
                v-model="recovery_modal.user_email"
                type="email"
                required
                placeholder="Scrivi il tuo indirizzo email"
              ></b-form-input>
            </b-input-group>
        </b-form-group>
        <div class="text-right">
        <b-button class="mr-2" type="submit" variant="primary">Invia</b-button>
        <b-button @click="hide_recovery_modal">Annulla</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import MD5 from 'crypto-js/md5'
import axios from 'axios'

export default {
  name: 'LoginForm',
  mixins: [ customerStylesMixin ],
  data () {
    return {
      // Url del manuale per l'accesso in otp.
      // Dobbiamo per forza mettere l'url così com'è senza avvalerci della gestione dei link dinamica
      // come ad esempio per la documentazione, qui infatti non siamo ancora loggati nel sistema e quindi
      // non abbiamo il token per poter fare la chiamata verso il backend
      url_manuale_otp : "https://userportal.welfarebit.it/media/docs/guida_nuova_autenticazione_rev01.pdf",

      // Url del video per l'accesso in otp.
      // Per quanto riguarda il video e la pagina delle FAQ questa è ospitata in una sezione esterna
      // nel sito istituzionale ( la pagina è stata realizzata da welfarebit stessa ), non abbiamo
      // quindi problemi in questo caso.
      url_video_otp : "https://lp.welfarebit.it/it/istruzioni-autenticazione-a-2-fattori-piattaforma-welfarebit-userportal",

      // Costanti per definire il tipo di autenticazione
      // che stiamo gestendo.
      ENROLL_OTP: 'ENROLL_OTP',
      AUTH_OTP: 'AUTH_OTP',
      MAIL_OTP: 'MAIL_OTP',

      // Flag per attivare l'overlay di attesa
      // e testo dell'overlay da personalizzare
      // in base alle fasi del login.
      show_overlay : false,
      overlay_text : "",

      // Valori per il form di login, passaggio 1
      // del processo di autenticazione
      username : null,
      password : null,
      username_state : null,
      password_state : null,

      // Se il passaggio 1 è stato fatto con sso da Centro Paghe
      // un flag che lo segnala al passaggio 2, di modo tale da
      // inviare anche lo slug name di centro paghe.
      external_sso : false,
      sso_provider_slug : 'centro_paghe',

      // Valori per il form di login, passaggio 2
      // del processo di autenticazione ( codice OTP )
      otp : null,
      otp_state : null,

      // Valori per il form conferma della registrazione del secret, passaggio 3
      otp_confirm : null,
      otp_confirm_state : null,

      // Immagine esplicativa per l'autenticatore.
      authenticator_image: require('@/assets/otp_login/otp_example.png'),

      // Un flag che indica se visualizzare il form per l'inserimento dell'OTP
      // inizialmente false per visualizzare la parte di username e password
      show_otp : false,

      // Un flag che indica se visualizzare la b-card con il qr code per la registrazione
      // dell'autenticatore, inizialmente false.
      show_qr_code : false,

      // Stringa che indica se la metodologia di autenticazione
      // è OTP via SMS o OTP via autenticatore, inizialmente null
      // fintanto che non viene fatta la prima chiamata di validazione
      // per username e password.
      otp_type : null,

      // Check token ottenuto di volta in volta nelle varie chiamate
      otp_check_token : null,

      // Dati da usare per la fase di arruolamento, il qrcode e la relativa
      // secret da memorizzare nell'autenticatore.
      otp_qr_code : null,
      otp_secret : null,

      // Valori per la modale di recupero password
      recovery_modal : {
        user_email : null,
        otp : null
      }
    }
  },
  /**
   * Quando la view viene montata controlliamo se è stato passato il token per l'sso da Centro
   * Paghe:
   * - Se il token NON è presente allora l'utente deve loggarsi alla maniera usuale, quindi con username
   *   e password e poi tramite verifica OTP.
   * - Se il token E' PRESENTE allora l'utente effettua l'autenticazione con l'SSO di centro paghe,
   *   quindi la maschera di login deve effettuare solo la seconda parte della procedura quella di controllo
   *   dell'OTP.
   */
  mounted () {

    // Se non viene fornito il token per l'sso da centro paghe
    // non devo fare nulla, seguo il login classico.
    if ( this.cpsso_token === null ) {
      return;
    }

    // Se invece ho il token devo mostrare la schermata di blocco e fare
    // il check sso da backend, alla fine mostrerò il form per il check
    // dell'otp.
    this.overlay_text = "Accesso in corso, si prega di attendere...";
    this.show_overlay = true;

    // Eseguiamo la chiamata per il primo passaggio per l'autenticazione
    // specifico per Centro Paghe.
    axios.post( apiUrl.authapi.ssocp_token, { sso_token: this.cpsso_token } )
    .then( (response) => {

        // Controlliamo che l'otp tornato sia di un tipo valido, in questo
        // caso escludiamo l'OTP di arruolamento perchè la prima registrazione
        // deve essere stata fatta con username e password come usuale passando
        // da Welfarebit
        if (  response.data['type'] !== this.AUTH_OTP
              && response.data['type'] !== this.MAIL_OTP ) {
          // Togliamo l'overlay, torniamo alla pagina di login con il customer
          // corretto, segnaliamo in console l'errore e torniamo non andando avanti.
          this.show_overlay = false;
          let customer = this.$store.state.customer;
          this.$router.replace( { name : 'login', params : { customer } } );
          console.error('Invalid otp_type: ' + response.data['type'] );
          return;
        }

        // Aggiorniamo il check token da usare al secondo passaggio ma
        // soprattutto la metodologia di otp che stiamo gestendo,
        // se è un utente che richiede l'invio di un OTP via mail o
        // con autenticatore.
        // Non dovrebbe mai tornare un enroll_otp perchè il primo passaggio
        // lo si deve fare da Welfarebit ed avrei un errore nell'if sopra.
        this.otp_check_token = response.data['check-token'];
        this.otp_type = response.data['type'];
        this.show_overlay = false;

        // Segnalo al passo successivo che il primo passo
        // è stato fatto tramite sso
        this.external_sso = true;

        // Posso proseguire e visualizzare l'OTP ora.
        this.show_otp = true;

    }).catch( (error) => {

      this.show_overlay = false;

      // Se va male oltre a mostrare l'errore mi riporto alla pagina
      // di login, così che non si veda più il token passato, fornisco
      // per coerenza il nome del customer per a skin personalizzata
      // se settato nello store.
      let customer = this.$store.state.customer;
      this.$router.replace( { name : 'login', params : { customer } } );

      generalLib.backend_error_message_box(this, error.response.data);

    });

  },
  computed : {
    /**
     * Indica che siamo nella fase di arruolamento di un
     * utente che deve registrarsi con l'autenticatore.
     */
    is_enroll_otp : function () {
      return this.otp_type === this.ENROLL_OTP ? true : false;
    },

    /**
     * Indica che siamo nella fase di autenticazione di un
     * utente che ha già registrato l'autenticatore.
     */
    is_auth_otp : function () {
      return this.otp_type === this.AUTH_OTP ? true : false;
    },

    /**
     * Indica se stiamo usando la mail come metodo di autenticazione
     * OTP.
     */
    is_mail_otp : function () {
      return this.otp_type === this.MAIL_OTP ? true : false;
    },

    /**
     * Visualizza la label corretta per il form OTP a seconda dell'otp che devo validare
     */
    otp_code_label: function () {
      let label = "Apri l'app di autenticazione e inserisci il codice di sicurezza visualizzato";
      if (this.is_enroll_otp) {
        label = "<h5 class=\"text-center mt-2 mb-2\">Registrazione dell'autenticatore</h5>" +
                "<p>Per garantire una miglior sicurezza dei dati degli utilizzatori della piattaforma, Welfarebit prevede una modalità di accesso mediante app Authenticator.</p>" +
                "<p>Nella prossima schermata saranno indicati tutti i passaggi da seguire per portare a termine con successo la procedura.</p>" +
                "<p>Accedi alla procedura <b>inserendo nel campo sottostante il codice di registrazione ricevuto via mail.</b></p>" +
                "<p><b>Non chiudere questa pagina mentre attendi che arrivi il messaggio.</b></p>";
      }
      if ( this.is_mail_otp ) {
        label = "Per completare l'accesso per favore inserisci il codice di sicurezza che hai ricevuto nella tua casella email " +
                this.username + " e clicca il tasto 'Verifica':";
      }

      return label;
    },
    /**
     * Visualizza il placeholder corretto per il form OTP a seconda dell'otp che devo validare
     */
    otp_placeholder_label: function () {
      let label = "Scrivi il codice di sicurezza";
      if (this.is_enroll_otp) {
        label = "Scrivi il codice di registrazione";
      }
      if ( this.is_mail_otp ) {
        label = "Scrivi il codice";
      }
      return label;
    },
    /**
     * Una computed che partendo dai dati in base 64 del Qr Code
     * restituisce la corretta stringa per poterlo visualizzare come immagine.
     */
    qr_code_img : function () {
      return "data:image/png;base64," + this.otp_qr_code;
    }
  },
  methods : {

    /**
     * Un semplice funzione che ricarica la pagina da capo
     * se l'utente dalla verifica OTP vuole tornare indietro
     * e ricominciare.
     */
    page_reload : function () {
      location.reload();
    },

    /**
     * A fronte di username e password corretti, verifica che tipo di OTP
     * deve essere inviato e fa avanzare l'utente alla fase successiva.
     */
    prosegui_ad_otp : function () {
      if ( ! this.credenziali_ok() ){
        return;
      }

      // Visualizziamo l'overlay
      this.overlay_text = "Verifica credenziali in corso...";
      this.show_overlay = true;

      // Prepariamo la stringa base64 da inviare al backend.
      // Effettuiamo quindi l'MD5 della password e prepariamo il json da mascherare
      let md5pwd = MD5( this.password );
      let login_data = { username : this.username, password : md5pwd.toString() };

      // Convertiamo in stringa il json e quindi in base64, prepariamo
      // infine il json da inviare in post, la stringa base64 viene inviata
      // nella chiave "akey"
      let b64_login_string = btoa( JSON.stringify( login_data ) );
      let post_data = { akey : b64_login_string };

      // Chiamiamo il backend il quale a fronte di username e password corretti
      // ci da il token di verifica per il secondo passaggio e visualizza il form
      // otp.
      axios.post( apiUrl.authapi.get_token, post_data )
      .then( (response) => {

          // Controlliamo che l'otp tornato sia di un tipo valido
          // se non è corretto lo scriviamo in console, togliamo l'overlay
          // e non andiamo avanti
          if ( response.data['type'] !== this.ENROLL_OTP
                && response.data['type'] !== this.AUTH_OTP
                && response.data['type'] !== this.MAIL_OTP ) {
            this.show_overlay = false;
            console.error('Invalid otp_type: ' + response.data['type'] );
            return;
          }

          // Aggiorniamo il check token da usare al secondo passaggio ma
          // soprattutto la metodologia di otp che stiamo gestendo,
          // se è un arruolmento per l'autenticatore, un autenticazione di un
          // utente che è già arruolato o un invio di otp via mail.
          this.otp_check_token = response.data['check-token'];
          this.otp_type = response.data['type'];
          this.show_overlay = false;
          this.show_otp = true;

          // Verifichiamo anche se, a fronte di un otp di primo arruolamento, l'utente
          // sta usando un dispositivo mobile o tablet, gli notifichiamo in tal caso che
          // è meglio usare un pc per la prima registrazione.
          if ( response.data['type'] === this.ENROLL_OTP ) {
            this.visualizza_avviso_se_mobile();
          }

      }).catch( (error) => {
        this.show_overlay = false;
        generalLib.backend_error_message_box(this, error.response.data);
      });

    },

    /**
     * Esegue il controllo sulla presenza delle credenziali come ulteriore sicurezza
     * se il check dell'html fallisce.
     *
     * Torna true se il check è ok, false altrimenti.
     */
    credenziali_ok : function () {
      this.username_state = this.username === null ? false : true;
      this.password_state = this.password === null ? false : true;
      return this.username_state == true &&  this.password_state == true ? true : false;
    },

    /**
     * Esegue la verifica dell'otp, questo può essere diretto o al primo arruolamento
     * per un utente che deve registrare il suo atuenticatore o ad un utente che ha già
     * l'autenticatore registrato, od infine anche ad un utente che invece segue ancora
     * il metodo di autenticazione con OTP via mail.
     */
    verifica_otp : function () {
      if ( ! this.otp_ok() ){
        return;
      }

      // Visualizziamo l'overlay
      this.overlay_text = "Verifica codice di sicurezza in corso...";
      this.show_overlay = true;

      if ( this.is_enroll_otp ) {
        // Dobbiamo ancora arruolare l'autenticatore, la funzione di verifica è quella
        // specifica per questo caso che ci restituirà il qrcode e la secret.
        this.verifica_otp_per_arruolamento();
      } else {
        // Abbiamo già l'autenticatore arruolato, oppure l'utente usa un OTP via mail.
        // Possiamo andare direttamente al check dell'OTP fornito.
        this.valida_otp_auth_e_fai_login();
      }
    },

    /**
     * Esegue la verifica dell'otp per arruolamento, in caso positivo vengono ricevuti il QRcode
     * e la secret per far registrare l'utente.
     */
    verifica_otp_per_arruolamento: function() {

      // La chiamata in questo caso ci restituisce il qrcode da far usare all'utente,
      // dobbiamo quindi andare a visualizzarlo.
      // Visualizziamo anche la secret per gli esegue la procedura da telefono e non può
      // quindi inquadrare il qr code.
      // Usiamo il check token ottenuto dal primo passaggio, quello dello username e password.
      axios.post( apiUrl.authapi.otp_verify, { check_token: this.otp_check_token, otp: this.otp } )
      .then( (response) => {

          this.show_overlay = false;

          // Errore critico, non può mancare il qr_code!
          if ( !Object.prototype.hasOwnProperty.call(response.data, 'qr_code') ){
            throw new Error('Qr code data missing');
          }

          // Memorizziamo i dati ottenuti dalla chiamata, il check token per la terza fase
          // ( la conferma della registrazione ) ed il qr code e la secret da visualizzare.
          this.otp_check_token = response.data['check_token'];
          this.otp_qr_code = response.data['qr_code'];
          this.otp_secret = response.data['secret'];

          // Possiamo ora nascondere il form otp e visualizzare il qr code
          this.show_otp = false;
          this.show_qr_code = true;

      }).catch( (error) => {
        this.show_overlay = false;
        generalLib.backend_error_message_box(this, error.response.data);
      });

    },

    /**
     * Una volta che l'utente ha registrato il suo secret nell'autenticatore
     * permette di fargli confermare l'operazione e quindi associare il secret
     * al suo account immettendo un primo codice otp come controprova.
     */
    conferma_registrazione_qrcode : function () {

      // Verifichiamo che l'otp di controllo sia stato immesso altrimenti non andiamo avanti.
      if ( this.otp_confirm === null || this.otp_confirm === "" ) {
        this.otp_confirm_state = false;
        return;
      }

      // Altrimenti procediamo con la chiamata di conferma.
      this.overlay_text = "Conferma registrazione utente...";
      this.show_overlay = true;

      // Usiamo il check token ottenuto nel momento in cui verificando con successo il codice di primo arruolamento,
      // viene restituito il qr_code.
      axios.post(apiUrl.authapi.auth_confirm, { check_token: this.otp_check_token, otp: this.otp_confirm } )
      .then((response) => {

        this.show_overlay = false;

        // Se tutto ok si riceve un 204_NO_CONTENT quindi dobbiamo solo informarne l'utente
        let message = "Registrazione completata, verrai indirizzato alla pagina di login per accedere alla piattaforma e " +
                      "se necessario, per effettuare il primo cambio password.";
        this.$bvModal.msgBoxOk(message, {
            title: 'Registrazione completata',
            centered: true
          })
          .then((value) => {
            // Al click sull'ok ricarichiamo la pagina
            this.overlay_text = "Reindirizzamento in corso...";
            this.show_overlay = true;
            this.page_reload();
          });
      })
      .catch((error) => {
        this.show_overlay = false;
        this.otp_confirm_state = false;
        generalLib.backend_error_message_box(this, error.response.data);
      });

    },

    /**
     * Esegue la verifica dell'otp da autenticatore o mail, in caso positivo alla
     * ricezione del token di sessione fa login.
     * Se il primo passaggio era stato effettuato come sso da Centro Paghe,
     * invia lo slug_name di centro paghe per segnalarlo al backend.
     */
    valida_otp_auth_e_fai_login : function () {

      // Prepariamo i dati per la post, arriviamo da qui dopo aver fatto
      // il primo passaggio sso con Centro Paghe dobbiamo anche aggiungere
      // il suo slugname identificativo.
      let post_data = { check_token: this.otp_check_token, otp: this.otp };
      if ( this.external_sso ) {
        post_data.sso_provider_slug = this.sso_provider_slug;
      }

      // La chiamata in questo caso ci restituisce il token di sessione, usiamo quindi la
      // action di login per memorizzarlo nello store e quindi fare login.
      // Usiamo il check tocken ottenuto dal primo passaggio, quello dello username e password.
      this.$store.dispatch( 'login', post_data ).then( () => {

        // Login ok! Andiamo alla home ( in realtà al menu perchè la home è cmq redirezionata qui )
        // non togliamo l'overlay, aspettiamo che il router faccia il suo lavoro.
        this.$router.push( { name: 'menu' } )

      })
      .catch((error) => {

        this.show_overlay = false;

        // Controlliamo poi se la password è scaduta ( la richiesta torna un oggetto con
        // il solo attributo password_expired a true ), in caso affermativo non andiamo
        // oltre ed eseguiamo l'invio della mail con il token di modifica password alla
        // mail dell'utente.
        if (Object.prototype.hasOwnProperty.call(error.response.data, 'password_expired') &&
          error.response.data.password_expired === true) {
          this.esegui_rinnovo_password();
          return;
        }

        // Altri messaggi.
        generalLib.backend_error_message_box(this, error.response.data);

      });

    },

    /**
     * Esegue la verifica sull'inserimento dell'otp in aggiunta al required
     * html.
     */
    otp_ok : function() {
      this.otp_state = this.otp === null ? false : true;
      return this.otp_state;
    },

    /**
     * Verifica se l'utente sta usando un dispositivo mobile o tablet
     * per visualizzare il form di login di prima registrazione.
     * In tal caso gli consigliamo di usare un pc per la prima autenticazione.
     *
     * Funzione di controllo dispositivo mobile presa da:
     * https://medium.com/simplejs/detect-the-users-device-type-with-a-simple-javascript-check-4fc656b735e1
     *
     * L'alert viene visualizzato solo se l'utente sta facendo la prima registrazione
     */
    visualizza_avviso_se_mobile: function () {

      var check = false;
      (function(a){
          //eslint-disable-next-line
          if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
              check = true;
      })(navigator.userAgent||navigator.vendor||window.opera);

      if ( !check ) {
        return false;
      }

      const h = this.$createElement;
      const messageVNode = h('div', {}, [
                              h('p', { class: ['text-justify'] }, [h('b', {}, 'Sembra tu stia effettuando la prima registrazione da un dispositivo mobile ( telefono/tablet )')]),
                              h('p', { class: ['text-justify'] }, [h('b', {}, 'Ti consigliamo di utilizzare un PC unitamente al tuo telefono o tablet'), ' e seguire le istruzioni fornite per completare agevolmente la procedura.']),
                              h('p', { class: ['text-justify'] }, [h('b', {}, 'Se non puoi utilizzare un PC'), ', puoi comunque continuare, ma dovrai inserire manualmente il codice segreto nella app di autenticazione.'])
                            ]);

      this.$bvModal.msgBoxOk( [messageVNode], {
          title: 'Attenzione: dispositivo mobile',
          size: 'sm',
          buttonSize: 'sm',
          centered: true
      })

    },

     /**
     * Copia il secret visualizzato a schermo in fase di arruolamento negli apputni
     * creando una textarea invisibile che viene aggiunta e poi rimossa.
     * Una volta copiato lo notifica con un toast che poi scompare da solo.
     */
    copia_secret_negli_appunti : function () {
      // Copio
      const el = document.createElement('textarea');
      el.value = this.otp_secret;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      // Notifico con toast.
      let message = "Codice copiato negli appunti, puoi incollarlo ora nella app di autenticazione";
      this.$bvToast.toast( message, {
        title: 'Azione eseguita.',
        toaster: 'b-toaster-bottom-center',
        //solid: true,
        autoHideDelay: 1500,
        variant: 'success',
        appendToast: false
      });
    },

    /**
     * Visualizza la modale di recupero password
     */
    show_recovery_modal : function () {
      this.$refs['passwd_recovery_modal'].show();
    },

    /**
     * Nasconde la modale di recupero
     */
    hide_recovery_modal : function () {
      this.$refs['passwd_recovery_modal'].hide();
    },

    /**
     * Resetta lo stato della modale, utile per "pulirla" quando viene
     * visualizzata ( se si compila il dato, si chiude la modale e poi si riapre )
     */
    reset_recovery_modal : function () {
      this.recovery_modal.user_email = null;
      this.recovery_modal.otp = null;
    },

    /**
     * Prende l'email utente dal form della modale di recovery e chiama l'url per l'avvio
     * della procedura di recovery della password perduta ( invio link di recupero tramite email )
     */
    esegui_password_recovery: function () {

      // Nascondiamo la modale e avviamo la procedura di recupero
      this.hide_recovery_modal()

      let interface_url = document.location.origin;

      let data_to_send = { user_email    : this.recovery_modal.user_email,
                           customer      : this.$store.state.customer,
                           interface_url : interface_url }

      axios.post( apiUrl.userapi.password_lost, data_to_send )
      .then( ( response ) => {

        const h = this.$createElement;
        const messageVNode = h('div', {}, [
                                h('p', { class: ['text-justify'] }, "La procedura di recupero si è conclusa con successo, se l'email inserita esiste nei nostri sistemi, entro qualche minuto riceverai il un messaggio con il link per il reset della password." ),
                                h('p', { class: ['text-justify'] }, "Se la mail non compare nella tua posta in arrivo controlla nella cartella spam." ),
                                h('p', { class: ['text-justify'] }, "Se non ricevi la mail prova di nuovo o contatta la nostra assistenza ")
                              ]);
        this.$bvModal.msgBoxOk( [ messageVNode ], {
          title: 'Recupero password dimenticata',
          centered: true
        })
      })
      .catch( ( error ) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },

    /**
     * Avvia la procedura per il cambio password scaduta con l'invio di una mail all'utente
     * con il link per la modifica.
     */
    esegui_rinnovo_password: function () {

      let interface_url = document.location.origin;

      // In questo caso la mail la prendiamo direttamente dal contenuto del form
      // inserito dall'utente durante il primo passaggio dell'autenticazione.
      let data_to_send = { user_email    : this.username,
                           customer      : this.$store.state.customer,
                           interface_url : interface_url }

      axios.post( apiUrl.userapi.password_expired_renew, data_to_send )
      .then( ( response ) => {

          // Disattiva l'overlay che era stato attivato dalla chiamata di autentiazione
          // dell'otp, cioè il chiamante di questa funzione
          this.show_overlay = false;

            // Se tutto ok si riceve un 204_NO_CONTENT quindi dobbiamo solo informarne l'utente
          const h = this.$createElement;
          const messageVNode = h('div', {}, [
                                  h('p', { class: ['text-justify'] }, [ "Ci preoccupiamo per la tua sicurezza, per questo ti chiederemo di ", h('b', {}, 'modificare la password con cadenza regolare.') ] ),
                                  h('p', { class: ['text-justify'] }, [ "Per fare questo riceverai entro pochi minuti ", h('b', {}, 'una mail con il link necessario al rinnovo.') ] ),
                                  h('p', { class: ['text-justify'] }, "Se la mail non compare nella tua posta in arrivo controlla nella cartella spam. Se non ricevi la mail prova di nuovo o contatta la nostra assistenza.")
                                ]);

          this.$bvModal.msgBoxOk( [messageVNode], {
            title: 'Rinnovo password scaduta',
            centered: true
          })
          .then( ( value ) => {
            // Al click sull'ok ricarichiamo la pagina
            this.overlay_text = "Ti stiamo riportando alla pagina iniziale...";
            this.show_overlay = true;
            this.page_reload();
          });
      })
      .catch( ( error ) => {
        // Disattiva l'overlay che era stato attivato dalla chiamata di autenticazione
        // dell'otp, cioè il chiamante di questa funzione
        this.show_overlay = false;

        generalLib.backend_error_message_box( this, error.response.data );
      });

    }
  },
  props : {
    /**
     * Si tratta del token inviato da Centro Paghe per effettuare la propria
     * procedura si SSO, se presente il form di login interroga i server centro
     * paghe ( tramite backend ) per sostituire con l'sso la parte di username
     * e password. Rimane però il controllo dell'OTP.
     */
    cpsso_token: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    CustomOverlay
  }
}
</script>

<style scope>
#otp-group > label {
  text-align: justify;
}
.code-link {
  color: #525252;
  text-decoration: none;
}
.code-link:hover {
  color: #787878;
  text-decoration: none;
}
</style>
